<template>
  <!-- 编辑群组 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="editgroup"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">编辑群组</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <input
              class="form-control"
              placeholder="群组名称"
              type="text"
              v-model.trim="form.group_name"
              name="group_name2"
              data-vv-as="群组名称 "
              v-validate="{ required: true, max: 50 }"
            />
            <span class="help-block" v-show="errors.has('group_name2')">{{
              errors.first("group_name2")
            }}</span>
          </div>
          <div class="form-group">
            <textarea
              class="form-control"
              placeholder="群组简介"
              style="resize: vertical"
              rows="4"
              v-model="form.group_description"
              name="group_description2"
              data-vv-as="群组简介 "
              v-validate="{ max: 255 }"
            ></textarea>
            <span
              class="help-block"
              v-show="errors.has('group_description2')"
              >{{ errors.first("group_description2") }}</span
            >
          </div>
          <div class="form-group">
            <select
              class="form-control selectpicker"
              v-model="form.group_category_number"
              name="group_category_number2"
              data-vv-as="群组分类 "
              v-validate="{ required: true }"
            >
              <option
                v-for="cate in categorys"
                :key="cate.group_category_number"
                :value="cate.group_category_number"
              >
                {{ cate.group_category_name }}
              </option>
            </select>
            <span
              class="help-block"
              v-show="errors.has('group_category_number2')"
              >{{ errors.first("group_category_number2") }}</span
            >
          </div>
          <!-- <div class="form-group">
            <div class="share-user">
              <div class="list" v-for="(tag,index) in form.group_tags" :key="index">
                <i class="ti-tag"></i>
                <p>{{tag.tag_name}}</p>
                <i class="ti-close close" @click="removeTag(index)"></i>
              </div>
              <input
                class="share-input"
                placeholder="群组标签"
                type="text"
                v-model.trim="tag"
                @keyup.enter="addTag"
                name="tag2"
                data-vv-as="群组标签 "
                v-validate="{ max: 10 }"
              />
            </div>
            <span class="help-block" v-show="errors.has('tag2')">{{ errors.first('tag2') }}</span>
          </div>-->
          <div class="form-group">
            <div class="upload-groupavator">
              <div class="preview" id="view">
                <img
                  v-if="form.group_logo || cropImg"
                  :src="cropImg || form.group_logo"
                  style="width: 60px; height: 60px"
                />
                <input
                  id="filebtn"
                  :value="uploadValue"
                  type="file"
                  accept="image/jpg, image/jpeg, image/gif, image/png"
                  name="image"
                  @change="setImage"
                />
              </div>
              <button
                v-show="imgSrc"
                type="button"
                class="btn btn-danger btn1"
                @click="cancleCropImage"
              >
                取消
              </button>
              <p :style="pStyle" v-show="!imgSrc">点击这里更改logo</p>
              <p :style="pStyle">logo裁剪大小为400*400像素</p>
            </div>
          </div>
          <!-- <div class="form-group">
            <div class="checkbox i-checks">
              <label>
                <input type="checkbox" v-model="form.is_public" />
                <i></i>
                群组公开可见
              </label>
            </div>
          </div>-->
          <div class="form-group">
            <div class="checkbox i-checks">
              <label>
                <input
                  type="checkbox"
                  v-model="form.group_is_auto_audit_mem_add"
                />
                <i></i>
                成员申请入群自动审核通过
              </label>
            </div>
          </div>
          <div class="form-group">
            <div class="checkbox i-checks">
              <label>
                <input
                  name="is_agree_protocol2"
                  type="checkbox"
                  v-model="form.is_agree_protocol"
                  @change="changeAgreeProtocol"
                />
                <i></i>
                同意
                <router-link
                  target="_blank"
                  :to="{ name: 'content' }"
                  style="color: #006adf"
                  >《群使用协议》</router-link
                >
              </label>
            </div>
            <span
              class="help-block"
              v-show="errors.has('is_agree_protocol2')"
              >{{ errors.first("is_agree_protocol2") }}</span
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            data-dismiss="modal"
            type="button"
            v-show="!loading"
          >
            取消
          </button>
          <button
            class="btn btn-primary"
            :class="{ loading: loading }"
            type="button"
            @click="saveGroup"
          >
            {{ updateText }}
          </button>
        </div>
      </div>
      <div class="crop-image" v-if="imgSrc && showCropper">
        <vue-cropper
          ref="cropper3"
          :guides="true"
          :view-mode="2"
          drag-mode="crop"
          :aspect-ratio="1"
          :auto-crop-area="0.9"
          :min-container-width="500"
          :min-container-height="400"
          :background="true"
          :rotatable="true"
          :src="imgSrc"
          alt="群Logo"
          :cropmove="cropMove"
          :img-style="{ width: '500px', height: '400px' }"
        ></vue-cropper>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import debounce from "lodash.debounce";
import { publicFileUpload } from "@/api/common/index";
import { getGroupCategorys, checkGroupName, group } from "@/api/group/group";
export default {
  name: "GroupEdit",
  components: { VueCropper },
  props: {
    group: {
      type: Object,
    },
  },
  data() {
    return {
      uploadValue: "",
      loading: false,
      showCropper: false,
      cropImg: "",
      imgSrc: "",
      tag: "",
      categorys: [],
    };
  },
  created() {
    this.debouncedCheckGroupName = debounce(this.checkGroupName, 500);
  },
  watch: {
    //这个监听没起作用，不能监听group_name变化，因为form是computed
    "form.group_name": {
      handler: function (newValue) {
        if (newValue) {
          this.debouncedCheckGroupName();
        }
      },
    },
  },
  computed: {
    updateText() {
      return this.loading ? "正在提交..." : "提交";
    },
    pStyle() {
      return this.imgSrc
        ? "padding-left: 10px;line-height: 60px;"
        : "padding-left: 100px;line-height: 30px;";
    },
    form() {
      return Object.assign({ is_agree_protocol: true }, this.group);
    },
  },
  methods: {
    checkGroupName() {
      checkGroupName({
        group_number: this.group.group_number,
        search_name: this.form.group_name,
      })
        .then((res) => {
          if (res.status_code === 423) {
            this.errors.add({
              field: "group_name2",
              msg: res.message,
            });
          } else {
            this.errors.remove("group_name2");
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    cancleCropImage(reset = true) {
      this.form.group_logo = this.group.group_logo;
      this.imgSrc = "";
      this.showCropper = false;
      window.URL.revokeObjectURL(this.cropImg);
      if (reset) {
        this.cropImg = this.group.group_logo;
      } else {
        this.cropImg = "";
      }
      // this.$refs.cropper3.reset();
    },
    setImage(e) {
      this.uploadValue = "";
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      if (!file.type.includes("image/")) {
        this.$message({
          type: "warning",
          message: "请选择一个图片类型文件",
        });
        return;
      }
      this.cropImg = window.URL.createObjectURL(file);
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.showCropper = true;
          this.imgSrc = event.target.result;
          this.$nextTick(() => {
            this.$refs.cropper3.replace(event.target.result);
          });
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage(group_res) {
      if (!this.imgSrc) {
        this.$message({
          type: "success",
          message: group_res.message,
        });
        $("#editgroup").modal("hide");
        this.loading = false;
        this.$emit("groupCreated");
        return false;
      }
      this.$refs.cropper3
        .getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: false,
          imageSmoothingQuality: "high",
        })
        .toBlob((blob) => {
          const formData = new FormData();
          formData.append("file", blob);
          formData.append("type", 2);
          formData.append("group_number", group_res.entity.group_number);
          publicFileUpload(formData)
            .then((res) => {
              if (res.status_code === 200) {
                $("#editgroup").modal("hide");
                this.loading = false;
                this.$emit("groupCreated");
                this.cancleCropImage(false);
                this.showCropper = false;
                // this.form.group_logo = res.entity.file_url;
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                $("#editgroup").modal("hide");
                this.loading = false;
                this.$emit("groupCreated");
                this.cancleCropImage(false);
                this.$message({
                  type: "error",
                  message: "群组更新成功，" + res.message,
                });
              }
            })
            .catch((err) => {
              $("#editgroup").modal("hide");
              this.loading = false;
              this.$emit("groupCreated");
              this.cancleCropImage(false);
              this.$message({
                type: "error",
                message: "群组更新成功，" + err,
              });
            });
        });
    },
    cropMove() {
      this.cropImg = this.$refs.cropper3
        .getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: false,
          imageSmoothingQuality: "high",
        })
        .toDataURL();
    },
    // addTag() {
    //   this.$validator.validate("tag2").then(valid => {
    //     if (valid) {
    //       groupTags({
    //         action: "add",
    //         groups_list: [
    //             group_number: this.group.group_number
    //         ],
    //         tags_list: [
    //           {
    //             tag_name: this.tag
    //           }
    //         ]
    //       })
    //         .then(res => {
    //           if (res.status_code === 200) {
    //             this.form.group_tags.push({
    //               name: this.tag
    //             });
    //             this.tag = "";
    //           } else {
    //             this.$message({
    //               type: "error",
    //               message: res.message
    //             });
    //           }
    //         })
    //         .catch(error => {
    //           console.log(error);
    //           this.$message({
    //             type: "error",
    //             message: "标签添加失败"
    //           });
    //         });
    //     }
    //   });
    // },
    // removeTag(index) {
    //   groupTags({
    //     action: "remove",
    //     groups_list: [
    //         group_number: this.group.group_number
    //     ],
    //     tags_list: [
    //         tag_name: this.form.group_tags[index].name
    //     ]
    //   })
    //     .then(res => {
    //       if (res.status_code === 200) {
    //         this.form.group_tags.splice(index, 1);
    //       } else {
    //         this.$message({
    //           type: "error",
    //           message: res.message
    //         });
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.$message({
    //         type: "error",
    //         message: "标签删除失败"
    //       });
    //     });
    // },
    getGroupCategorys() {
      getGroupCategorys()
        .then((res) => {
          this.categorys = res.entity;
        })
        .catch();
    },
    changeAgreeProtocol() {
      if (this.form.is_agree_protocol) {
        this.errors.remove("is_agree_protocol2");
      } else {
        this.errors.add({
          field: "is_agree_protocol2",
          msg: "请选择同意群使用协议",
        });
      }
    },
    saveGroup() {
      if (this.errors.has("group_name")) {
        return false;
      }
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.form.is_agree_protocol) {
            this.errors.add({
              field: "is_agree_protocol2",
              msg: "请选择同意群使用协议",
            });
            return false;
          }
          let iform = {
            group_number: this.form.group_number,
            group_category_number: this.form.group_category_number,
            group_name: this.form.group_name,
            group_description: this.form.group_description,
            group_logo: this.form.group_logo,
            group_banner: this.form.group_banner,
            is_public: this.form.group_is_public,
            is_agree_protocol: true,
            is_auto_audit_mem_add: this.form.group_is_auto_audit_mem_add,
          };
          group(iform)
            .then((res) => {
              if (res.status_code === 200) {
                this.cropImage(res);
              } else {
                this.loading = false;
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
  },
  mounted() {
    $("#editgroup").on("show.bs.modal", () => {
      this.getGroupCategorys();
    });
  },
  destroyed() {
    $("#editgroup").off();
  },
};
</script>

<style scoped>
.loading {
  pointer-events: none;
}
.group_logo {
  width: 80px;
  height: 80px;
}
#newgroup-dialog {
  position: relative;
}
.crop-image {
  /* z-index: 9999; */
  position: absolute;
  top: 0px;
  left: -500px;
  width: 500px;
  height: 300px;
}
.upload-groupavator .btn1 {
  margin-left: 90px;
  display: inline-block;
}
.upload-groupavator .btn2 {
  margin-left: 10px;
  display: inline-block;
}
</style>